// Per brand: the code in its logo file names, and its defaults. widgetColor is the Wind Widgets'
// color before the user picks one (legacy web.config <Widgets defaultColor>).
export const BRANDS = {
  windalert: {
    code: 'wa',
    defaults: { widgetColor: '#870100' }
  },
  ikitesurf: {
    code: 'ik',
    defaults: { widgetColor: '#1E1E1E' }
  },
  iwindsurf: {
    code: 'iw',
    defaults: { widgetColor: '#163770' }
  },
  fishweather: {
    code: 'fw',
    defaults: { widgetColor: '#0A2946' }
  },
  sailflow: {
    code: 'sf',
    defaults: { widgetColor: '#0A2946' }
  }
};
